import { Link } from 'react-router-dom';
import { useStoreConfig } from '@/contexts/StoreConfigContext';

export default function Logo({ variant = 'dark', className = '' }) {
  const { config } = useStoreConfig();
  const storeName = config?.store_name || 'Florashop';
  const logoUrl = config?.logo_url;
  const tagline = config?.tagline || '';
  const color = variant === 'light' ? '#fff' : '#000';

  if (logoUrl) {
    return (
      <Link to="/" data-testid="header-logo" className={className}>
        <img src={logoUrl} alt={storeName} className="h-8 md:h-10 object-contain" />
      </Link>
    );
  }

  const words = storeName.split(' ');
  const first = words[0] || '';
  const rest = words.slice(1).join(' ');

  return (
    <Link to="/" data-testid="header-logo" className={`flex flex-col items-start leading-none ${className}`}>
      <span className="tracking-[0.08em]" style={{ color }}>
        <span className="font-serif text-xl font-light">{first}</span>
        {rest && <span className="font-serif text-xl font-bold ml-1">{rest}</span>}
      </span>
      {tagline && (
        <span className="font-serif text-[8px] italic tracking-[0.12em] mt-0.5 hidden md:block"
          style={{ color: variant === 'light' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.4)' }}>
          {tagline.length > 40 ? tagline.slice(0, 40) : tagline}
        </span>
      )}
    </Link>
  );
}
